import React from 'react';
import Projects from './Projects';

// Keep the existing employee navigation URL, but manage projects in place.
export default function AccountPortals() {
  return <Projects employeeView />;
}
